import { useMemo } from "react"
import { appConstants } from "../../appConstants"
import { BSLevel } from "../../dto/beem-shot/BSBuildingLevel/BSLevel"
import { BSLevelForm } from "../../dto/beem-shot/BSBuildingLevel/BSLevelForm"
import { useHttp } from "../use-http"

type BSBuildingLevelHook = {
  createBSLevelList(bsBuildingId: string, bsBuildingLevelList: BSLevelForm[]): Promise<BSLevel[]>
  getBSLevelList(bsBuildingId: string): Promise<BSLevel[]>
}

export function useBSLevel(): BSBuildingLevelHook {
  const { post, get } = useHttp()

  return useMemo(
    () => ({
      createBSLevelList(bsBuildingId: string, bsLevelForms: BSLevelForm[]): Promise<BSLevel[]> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_LEVEL_LIST, bsLevelForms, [
          { key: "bsBuildingId", value: bsBuildingId },
        ]).then((response) => response.json())
      },
      getBSLevelList(bsBuildingId: string): Promise<BSLevel[]> {
        return get(appConstants.apiEndpoints.BEEM_SHOT_BUILDING_LEVEL_LIST, [
          { key: "bsBuildingId", value: bsBuildingId },
        ]).then((response) => response.json())
      },
    }),
    [post, get]
  )
}
